import React from 'react';
import { Page } from '../Page';
export function Page2() {
  return <Page pageNumber={6} variant="light" data-id="element-343">
      <div className="flex flex-col h-full" data-id="element-344">
        {/* Accent image strip */}
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-345">
          <img src="https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=1000&q=80" alt="Healthy food spread" className="w-full h-full object-cover object-center" data-id="element-346" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-347" />
        </div>

        <div className="mb-8" data-id="element-348">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-349">
            The Fundamentals
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-350">
            The <span className="text-tealslate" data-id="element-351">Fundamentals</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-352" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-12" data-id="element-353">
          <div className="space-y-4" data-id="element-354">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-355">
              Traditional nutrition advice starts with calories. Count them, cut
              them, track them. Everything else comes second. For most people,
              that's still the playbook.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-356">
              But GLP-1 medication flips the script. The medication is already
              creating your caloric deficit by reducing appetite and slowing
              digestion. So calories move to the bottom of the list.
            </p>
          </div>
          <div className="space-y-4" data-id="element-357">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-358">
              That changes everything. Now you build from the ground up.
              Protein, vitamins, omega-3s, fiber, and weight lifting become your
              foundation. These are the nutrients and habits that protect your
              muscle, your energy, and your health while the medication handles
              the rest.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-359">
              All five are equally important. They are not ranked. They work
              together. And you can realistically start all of them today.
            </p>
          </div>
        </div>

        {/* Pyramid */}
        <div className="flex-1 flex flex-col items-center justify-center space-y-3 w-full max-w-lg mx-auto" data-id="element-360">
          <div className="w-1/3 bg-tealslate text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-361">
            Protein
          </div>
          <div className="w-1/2 bg-[#7A9BA5] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-362">
            Vitamins & Minerals
          </div>
          <div className="w-2/3 bg-[#6B8A94] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-363">
            Omega-3 Fatty Acids
          </div>
          <div className="w-5/6 bg-[#5C7983] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-364">
            Fiber
          </div>
          <div className="w-full bg-[#4D6872] text-white py-3 text-center font-bold text-sm shadow-sm" data-id="element-365">
            Weight Lifting
          </div>
        </div>
      </div>
    </Page>;
}